/* @flow */
import { List } from 'immutable';
import type { ScoresEntryType } from './types';
import * as ActionTypes from './action-types.js';

/* Fetches all scores entries */
export const fetchScores = (): Object => ({
  type: ActionTypes.FETCH_ENTITY_SCORES_PAGE
});

export const updateFilters = (payload: Object, field?: string) => ({
  type: ActionTypes.UPDATE_PAGE_FILTERS,
  payload,
  field
});

export const resetFilters = () => ({ type: ActionTypes.RESET_PAGE_FILTERS });



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/actions.js